<template>
  <div class="clearfix main_center" v-loading.fullscreen.lock="loading">
    <div class="right-content clearfix">
        <el-form  label-width="120px" :style="{height:cardMinHeight}" :model="form" ref="form" class="form" :rules='rules'>
      <el-card class="box-card" style="position:relative;">
          <div slot="header" class="clearfix" >
            <span>面部信息</span>
          </div>
          <el-form-item label="人员头像：" class="errorMsgPos" prop='imgUrl' style="width:100%;" >
              <div style="height:360px;text-align: center;">
                  <img :src="form.imgUrl || defaultImg" alt="" :style="{'margin-top':form.imgUrl != ''?'0px':'80px'}">
                  <br>
                  <el-button type="default" icon="el-icon-camera"  style="position: absolute;bottom: 20px;left: calc(50% - 72px);" @click="cameraDialogVisible=true">面部信息录入</el-button>
              </div>
          </el-form-item>


      </el-card>
        <el-card class="box-card" style="margin-bottom: 0px">
            <div slot="header" class="clearfix">
                <span>人员信息</span>
            </div>

                <el-row :gutter="15">
                    <el-col :span="12">
                        <el-form-item label="姓名：" prop='personName' style="width:100%;">
                            <el-input v-model="form.personName" maxlength="6" show-word-limit></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="身份证号：" prop='idcard' style="width:100%;">
                            <el-input v-model="form.idcard" maxlength="18" show-word-limit></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="15">
                    <el-col :span="12">
                        <el-form-item label="角色：" prop='roleType' style="width:100%;" >
                            <el-select v-model="form.roleType" clearable value-key="value" style="width:100%;">
                                <el-option v-for="(item,index) in roleList"
                                           :key="index"
                                           :label="item.name"
                                           :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="所属交易中心：" prop='tradeId'>
                        <el-select v-model="form.tradeId"  style="width:100%;">
                          <el-option v-for="(item) in transactionCenterList" :key="item.id" :label="item.orgName" :value="item.id"></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                </el-row>

        </el-card>
        </el-form>

    </div>


    <div class="left-content">
      <div class="left-navbar">
        <el-button type="primary" plain size="small" style="margin-right:10px;" @click="save()">保存</el-button>
        <el-button @click="back()" size="small" style="margin-left:0;">返回</el-button>
      </div>
    </div>

      <!-- 拍摄照片弹窗 -->
      <CameraDialog :dialogVisible.sync="cameraDialogVisible" @dialogCancle="dialogCancleCamera"/>


  </div>
</template>

<script>
    import {mapState} from "vuex";
    import {isIdcard, strLength_2,} from "@/utils/validate";
    import CameraDialog from "@/components/cameraDialog";
    import {tabsCloseCurrentHandle} from '@/utils/routeTab';

    export default {
  components: {
      CameraDialog
  },
  data() {
    return {
        id: "",
        fileId:'',
        cardMinHeight:(document.documentElement.clientHeight - 672) + 'px',
        form: {
            id: '',
            imgUrl:"",
            roleType:"",
            personName:"",
            idcard:"",
        },
        defaultImg: require('@/assets/img/bigScreen/defaultHead.png'),
        cameraDialogVisible:false,
        rules:{

            imgUrl: [{required: true, message: '人员头像不能为空', trigger: 'blur'}],
            personName: [{required: true, message: '姓名不能为空', trigger: 'blur'}, {
                validator: strLength_2,
                trigger: 'blur'
            }],
            idcard: [{required: true, message: '身份证号不能为空', trigger: 'blur'}, {
                validator: isIdcard,
                trigger: 'blur'
            }],
            roleType: [
                { required: true, message: '请选择角色', trigger: 'change' }
            ],
            tradeId: [
                { required: true, message: '请选择交易中心', trigger: 'change' }
            ],
        },
        roleList:[],
      questName:'',  //申请单位
      questReason: '',  //申请出证原因
      disable:false,
      loading: false,
      user: '',
      pageSize: 10,//每页条数
      pageIndex: 1,//当前页
      total: 0,//总条数
      dataId: 0,
      formId: '',
      groupList: [],
      formInfo: {},
      tableData: [],
      transactionCenterList: [],


    }
  },

  filters: {},
  created() {
      this.getDic('jz_dgwitness_person_role');
      this.transactionCenterList = JSON.parse(sessionStorage.getItem("transactionCenterList"));

  },
  computed: {
    ...mapState({
      stateData: state => state.user
    })
  },

  activated() {

    // $route.query.id为首页通过 url跳转 带过来的参数
    this.id = (this.$route.query && this.$route.query.id) || (this.$route.params && this.$route.params.id) || '';
    this.getDetailById();
  },

  methods: {

      getDic(type) { // 获取字典

          this.$http.get('/sys/dictData/getList?type=' + type).then(res => {
              if (res.data.code === '1') {
                  switch (type) {
                      case 'jz_dgwitness_person_role':this.roleList = res.data.data;break;
                  }
              }
          })
      },

      //Dialog弹窗取消、获取上传人脸照片
      dialogCancleCamera(fileId, imagePath) {
          if(fileId){
              this.fileId = fileId
          }
          if(imagePath){
              this.form.imgUrl = imagePath;
          }
          this.cameraDialogVisible = false;

      },


    //列表查看进来根据id查询详情
    getDetailById() {

      if (this.id) {

        // 查询基本信息及流程id
        this.$http.get('/document/sysPersonFaces/get?id=' + this.id).then(res => {
          if (res.data.code === '1') {
            const data = res.data.data;
            this.form = {...data};
            const that = this;
            setTimeout(function(){
                that.$refs.form.clearValidate()
            },500)


          }
        })

      } else {
         this.form = {
             id: '',
             imgUrl:"",
             roleType:"",
             personName:"",
             idcard:"",
         }
         this.$refs['form'].resetFields();
      }

    },


    // 返回
    back() {
        // this.$router.go(-1);

        tabsCloseCurrentHandle();
        this.$router.push({
            name:'facial_info_list',
        })

    },


    save() {

        this.$refs['form'].validate((valid) => {
            if (valid) {
                //  人员信息保存
                this.$http.post('/document/sysPersonFaces/save', this.form).then(res => {
                    if (res.data.code == 1) {
                        this.$message({
                            type: 'success',
                            message: '保存成功。'
                        })
                        this.$router.push({
                            name: 'facial_info_list',
                        })
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.data.msg
                        })
                    }

                })

            }
        })


    },


  },
  deactivated() {
  },


}
</script>

<style lang="less" scope>

.bidFileList {
  width: 100%;
  border: 1px solid #ebeef5;
  border-spacing: 0;
  border-collapse: collapse;
  text-align: center;

  th {
    border: 1px solid #ebeef5;
    height: 40px;
  }

  td {
    border: 1px solid #ebeef5;
    height: 30px;
  }
}

.errorMsgPos{
    .el-form-item__error{
        top: calc(100% - 15px);
        left: calc(50% - 48px);
    }
}


</style>